import React from 'react';

const EPCCardDisplay: React.FC<any> = ({ epcCard, cardEPCId, cardExpiryDate, epcCardBarcode }) => {
  console.log("EPCCardDisplay", epcCard, cardEPCId, cardExpiryDate, epcCardBarcode)
  return (
    <div className="mb-4">
      <h3 className="text-purple-800 mb-4">EPC Card</h3>
      <div className="relative inline-block w-full max-w-md">
        <div className="relative">
          <img
            src={epcCard}
            alt="EPC Card"
            className="w-full rounded-lg"
          />
          
          {/* Valid Until Date */}
          <div className="absolute top-[140px] left-1/2 -translate-x-1/2 text-gray-700 w-full text-center">
            <div className="text-sm">Valid Until: {cardExpiryDate}</div>
          </div>
          
          {/* Barcode */}
          <div className="absolute bottom-16 left-1/2 -translate-x-1/2 w-full flex justify-center">
            <img
              src={epcCardBarcode}
              alt="EPC Card Barcode"
              className="w-1/2"
            />
          </div>

          {/* ID Number */}
          <div className="absolute top-[220px] left-1/2 -translate-x-1/2 text-gray-700 w-full text-center">
            <div className="text-sm">{cardEPCId}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EPCCardDisplay;